<template>
  <div>
    <Wizard :steps="stepValues" :currentStep="3" />
    <TabbedPortletContainer class="py-1">
      <router-view name="content" />
    </TabbedPortletContainer>
  </div>
</template>

<script>
import TabbedPortletContainer from '@/components/_shared/tabbed-portlet/TabbedPortletContainer.vue'
import Wizard from '@/components/_shared/wizard/Wizard.vue'
import WizardConfig from '@/components/_shared/wizard/config'
import ValidationsMixin from '@/mixins/validationsEditOpportunity.js'

export default {
  name: 'OpportunityEditContainer',
  mixins: [ValidationsMixin],
  components: {
    Wizard,
    TabbedPortletContainer
  },
  data () {
    return {
      stepValues: WizardConfig.stepValues
    }
  }
}
</script>
